import "./DeductionsInfoFieldsTableStyle.css";

import { FC, useEffect, useRef, useState } from "react";

import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { formatAmountCommaSeperator } from "../../../../common/Common";
import { Typography } from "@mui/material";

let columns = [
  {
    field: "title",
    headerName: "",
    footer: "Total Deduction",
  },
  {
    field: "income",
    headerName: "Income",
    footer: "0.00",
  },
  {
    field: "nonPeriodicPay",
    headerName: "Non Periodic Pay",
    footer: "0.00",
  },
  {
    field: "total",
    headerName: "Total",
    footer: "0.00",
  },
];

interface IDeductionsInfoFieldsTable {
  deductionsTableUpdatedData: (data: any) => void;
  deductionsFieldsDataItems: any;
}
export const DeductionsInfoFieldsTable: FC<
  IDeductionsInfoFieldsTable
> = ({ deductionsTableUpdatedData, deductionsFieldsDataItems, }) => {

  const [deductionsTable, setDeductionsTable] = useState<any>(
    deductionsFieldsDataItems
  );

  useEffect(() => {
    deductionsTableUpdatedData(deductionsTable);
  }, [deductionsTable]);

  useEffect(() => {
    setDeductionsTable(deductionsFieldsDataItems);
  }, [deductionsFieldsDataItems]);


  const onCellValueChange = (event: any, rowIndex: number, field: any) => {
    setDeductionsTable((prev: any) => {
      const updatedData = [...prev];

      const updatedRow = { ...updatedData[rowIndex], [event.field]: field };

      updatedData[rowIndex] = updatedRow;
      return updatedData;
    });
  };

  const columnsBody = (rowData: any, row: any, x: any) => {
    if (x.field === "title") {
      return (
        <InputText
          value={rowData[x.field] ?? ""}
          onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
          style={{ borderRadius: "2px" }}
          readOnly

        />
      );
    } else if (
      x.field === "income" ||
      x.field === "nonPeriodicPay" ||
      x.field === "total"
    ) {
      return (
        <span>
          {rowData[x.field] !== null && rowData[x.field] !== undefined
            ? `$ ${formatAmountCommaSeperator(rowData[x.field])}`
            : rowData[x.field]}
        </span>
      );
    }
    return <span>{formatAmountCommaSeperator(rowData[x.field])}</span>;
  };


  return (
    <>
      <div className="card">
        <DataTable
          value={deductionsTable}
          dataKey="id"
          showGridlines
          className="DeductionsInfoFieldsTableStyle"
          editMode="cell"
          // resizableColumns
          columnResizeMode="expand"
          scrollable
          // reorderableColumns
          filterDisplay="menu"
          scrollHeight="416px"

        >
          {columns.map((x: any, index: any) => {
            return (
              <Column
                key={index}
                field={x.field}
                header={x.headerName}
                columnKey={x.field}
                footer={x.footer}
                style={{
                  fontSize: "0.875rem",
                }}
                body={(rowData: any, row: any) => columnsBody(rowData, row, x)}
              />
            );
          })}
        </DataTable>
      </div>
    </>
  );
};
